import { isRenderingOnServer } from './isRenderingOnServer';

/**
 * Walks up the DOM from `node` and returns the nearest vertically scrollable
 * ancestor, or `null` when none is found.
 */
export const getScrollParent = (
  node: HTMLElement | null
): HTMLElement | null => {
  if (isRenderingOnServer()) {
    return null;
  }

  let current = node?.parentElement ?? null;

  while (current) {
    const { overflowY } = window.getComputedStyle(current);
    if (overflowY === 'auto' || overflowY === 'scroll') {
      return current;
    }
    current = current.parentElement;
  }

  return null;
};
